import { styled } from '@mui/system'
import { DateTerm } from '../../../../../utils/date'
import DateVO from '../../../../../vo/DateVO'
import { useCallback, useEffect, useState } from 'react'
import { DateSelect } from '../../../../components/toolbars/common'
import { DateSelectType } from '../../../../components/toolbars/common/DateSelect'

export enum SearchUnit {
  MONTH,
  DATE_RANGE,
}

type Props = {
  dateTerm: DateTerm
  onSearch: (term: DateTerm) => void
}

export const MonthRangeSelector = (props: Props) => {
  const now = DateVO.now()
  const [year, setYear] = useState<number>(now.getYear())
  const [month, setMonth] = useState<number>(now.getMonth())
  const [startDate, setStartDate] = useState<DateVO>(now.getFirstDayOfMonth())
  const [endDate, setEndDate] = useState<DateVO>(now.getLastDayOfMonth())
  const [execSearch, setExecSearch] = useState(false)

  useEffect(() => {
    const propStartDate = getFirstDayOfMonth()
    const propEndDate = getLastDayOfMonth()
    setYear(propStartDate.getYear())
    setMonth(propStartDate.getMonth())
    setStartDate(propStartDate)
    setEndDate(propEndDate)
  }, [props.dateTerm.startDate, props.dateTerm.endDate])

  useEffect(() => {
    if (!execSearch) return
    search()
    setExecSearch(false)
  }, [execSearch])

  const getFirstDayOfMonth = useCallback(() => {
    return props.dateTerm && props.dateTerm.startDate
      ? new DateVO(props.dateTerm.startDate)
      : DateVO.now().getFirstDayOfMonth()
  }, [props.dateTerm.startDate])

  const getLastDayOfMonth = useCallback(() => {
    return props.dateTerm && props.dateTerm.endDate
      ? new DateVO(props.dateTerm.endDate)
      : DateVO.now().getLastDayOfMonth()
  }, [props.dateTerm.endDate])

  const search = useCallback(() => {
    props.onSearch({
      startDate: startDate.formatForApi(),
      endDate: endDate.formatForApi(),
    })
  }, [props, startDate, endDate])

  const onChangeYearMonth = useCallback(value => {
    if (!value) return
    const date = new DateVO(value)
    setYear(date.getYear())
    setMonth(date.getMonth())
    setStartDate(date.getFirstDayOfMonth())
    setEndDate(date.getLastDayOfMonth())
    setExecSearch(true)
  }, [])

  return (
    <DateRangeRoot>
      <YearMonthSelect>
        <DateSelect
          type={DateSelectType.YEAR_MONTH}
          value={new DateVO(`${year}-${month}-1`)}
          onChange={onChangeYearMonth}
        />
      </YearMonthSelect>
    </DateRangeRoot>
  )
}

const DateRangeRoot = styled('div')({
  width: '100%',
  padding: '10px 0',
  marginRight: '8px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
})

const YearMonthSelect = styled('div')({
  width: '100px',
  zIndex: 3,
})
